import Routing from "routing/Routing";
import "./app.scss";
import "@milestone-sys/web-design-system/main.css";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Loader from "components/Loader/Loader";
import { useAppSelector } from "reducers/hooks";
import { selectIsAuthenticated } from 'reducers/userSlice'
import Redirect from "components/Redirect/Redirect";


function App() {
      const isAuthenticated = useAppSelector(selectIsAuthenticated)
    return (
        <div className="app">
            <Header />
            <Routing />
            {!isAuthenticated && <Redirect />}
            <Footer />
            <Loader />
        </div>
    );
}

export default App;
